import React from "react";

import CheckIcon from "@mui/icons-material/Check";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";

import OptionLabel from "./OptionLabel";

import styles from "./MenuOptionsWithCheckIfSelected.module.css";

interface Props {
  label: string;
  label2?: string;
  isChecked: boolean;
  onSelect: () => void;
  className?: string;
  labelClassName?: string;
  label2ClassName?: string;
  isDisabled?: boolean;
  shouldRenderTooltip?: (optionLabel: string) => boolean;
}

const MenuOptionWithCheckIfSelected: React.FC<Props> = ({
  label,
  label2,
  isChecked,
  onSelect,
  className,
  labelClassName,
  label2ClassName,
  isDisabled,
  shouldRenderTooltip,
}: Props) => {
  return (
    <div
      className={toClassName(
        styles.option,
        { [styles.disabled]: isDisabled },
        className
      )}
      onClick={onSelect}
    >
      {isChecked && <CheckIcon className={styles.checkIcon} />}

      <OptionLabel
        label={label}
        label2={label2}
        labelClassName={labelClassName}
        label2ClassName={label2ClassName}
        isDisabled={isDisabled}
        shouldRenderTooltip={shouldRenderTooltip}
      />
    </div>
  );
};

export default MenuOptionWithCheckIfSelected;
